// Define the locales supported by i18n
type SupportedLocale = 'en' | 'it' | 'es' | 'pt' | 'fr' | 'de' | 'zh' | 'no' | 'ja' | 'da' | 'el' | 'nl' | 'sv'

export default defineNuxtPlugin(async () => {
  const user = useUser()

  if (user.value === undefined) {
    const response = await fetchCurrentUser()
    user.value = response?.data
  }

  if (user.value) {
    // Set the user in Bugsnag
    const bugsnag = useBugsnag()
    if (typeof bugsnag.setUser === 'function') {
      bugsnag.setUser(user.value.id.toString(), user.value.email, user.value.full_name)
    }

    // Set the locale
    const { $i18n } = useNuxtApp()
    const userLang = user.value.language

    if (userLang && userLang !== $i18n.locale.value) {
      // Get available locales
      const availableLocales = $i18n.availableLocales as string[]

      // Only set locale if the user's language is available
      if (availableLocales.includes(userLang)) {
        await $i18n.setLocale(userLang as SupportedLocale)
      }
    }
  }
})
